/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2022. All Rights Reserved.
 #*
 #*===================================================================
*/

import { createAction, props } from '@ngrx/store';

import { Plan } from '@core/models';

export const loadPlans = createAction('[Shared] Load Plans');
export const loadPlansSuccess = createAction('[Shared] Load Plans Success', props<{ plans: Plan[] }>());
export const loadPlansFailure = createAction('[Shared] Load Plans Failure', props<{ errorMessage: string }>());
